import { useTags } from '@/hooks/useAuctions';
import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './TagPicker.module.css';

interface Props {
  selected: string[];
  onChange: (tags: string[]) => void;
  max?: number;
}

export const TagPicker = ({ selected, onChange, max = 3 }: Props) => {
  const { data: tags } = useTags();

  const toggle = (slug: string) => {
    haptic.selection();
    if (selected.includes(slug)) {
      onChange(selected.filter((s) => s !== slug));
    } else if (selected.length < max) {
      onChange([...selected, slug]);
    }
  };

  return (
    <div className={styles.grid}>
      {tags?.map((tag) => {
        const isActive = selected.includes(tag.slug);
        const disabled = !isActive && selected.length >= max;
        return (
          <button
            key={tag.id}
            type="button"
            onClick={() => !disabled && toggle(tag.slug)}
            disabled={disabled}
            className={clsx(
              styles.tile,
              isActive && styles.tileActive,
              disabled && styles.tileDisabled,
            )}
          >
            <span className={styles.tileLabel}>{tag.name_ru}</span>
            {isActive && (
              <svg className={styles.check} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="m5 12 5 5L20 7" />
              </svg>
            )}
          </button>
        );
      })}
    </div>
  );
};